import type React from 'react';

import { LoginForm } from '@/pages/signin/+Page';
import useMe from '@/renderer/utils/useMe';

export default function Guarded({
  children,
  subtitle,
  hideLogo,
}: {
  children: (React.ReactNode | JSX.Element)[] | React.ReactNode | JSX.Element;
  subtitle?: (React.ReactNode | JSX.Element)[] | React.ReactNode | JSX.Element | string;
  hideLogo?: boolean;
}) {
  const me = useMe();

  if (!me) {
    return <LoginForm guarded={true} subtitle={subtitle} hideLogo={hideLogo} />;
  }

  return children;
}
